module.exports = __webpack_public_path__ + "static/img/10commitments_8.ccdabc6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduction/10commitments_8.jpg
// module id = teen
// module chunks = 0